export default __webpack_public_path__ + "static/media/about.1c4a00d1.png";